export default __webpack_public_path__ + "static/media/fasting_unexpected@3x.a69d91e7.jpg";